import React, { useEffect, useState, useRef } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import ToolTipWrapper from '../Tooltip/ToolTipWrapper';
import Dropdown from  '@/components/elements/global/Dropdown'
import Toast, { ToastMessageType } from  '@/components/elements/global/ToastNotification';
import { container, TYPES } from  '@/inversifyconfig/container.config';
import { IHttpRequest } from  '@/interfaces/IHttp';
import { LockerSecuritySettings } from  '@/interfaces/LockerManagement';




const LockerSecurity = () => {
    const [setupProtectionValue, setSetupProtectionValue] = useState<number>(3);
    const setupProtectionOptions = mapValuesToOptions([0,1,3,7,14])
    
    const [setupOnboardingValue, setSetupOnboardingValue] = useState<number>(3);
    const setupOnboardingOptions = mapValuesToOptions([0,1,3,7,14])

    const [lastUpdate, setLastUpdate] = useState<{lastUpdate: string, UpdateBy: string}>({lastUpdate: '', UpdateBy:''})

    const [showToast, setShowToast] = useState<boolean>(false);
    const [toastProps, setToastProps] = useState<{message?: JSX.Element, type?: ToastMessageType}>({message: undefined, type: undefined});

    const currentProtectionValue = useRef<number>();
    const currentOnboardingValue = useRef<number>();
    
    
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);  

    useEffect(()=> {
        refreshSecurityValues();
    },[])

    function getValueInWords(value): string {
        if (value === 0) {
            return 'Always Allow';
        }
        else if (value ===1) {
            return '1 day'
        }
        else {
            return `${value} days`
        }
    }
    
    function mapValuesToOptions(values: number[]): {label: string, value: number}[] {
        return values.map(v => ({label: getValueInWords(v), value: v}))
    } 

    function getDefaultLabel(value: number): string{
        if (value || value === 0) {
            return getValueInWords(value)
        }
        else {
            return ''
        }
    }

    

    function refreshSecurityValues () {
        httpCall.get('locker/admin/settings')
            .then(({data}:{data: LockerSecuritySettings}) => {
                currentProtectionValue.current = data.setupProtectionWindowInDays;
                currentOnboardingValue.current = data.onboardingWindowInDays;
                setSetupProtectionValue(data.setupProtectionWindowInDays);
                setSetupOnboardingValue(data.onboardingWindowInDays);
                setLastUpdate({
                    lastUpdate: data.lastUpdatedDate,
                    UpdateBy: data.lastUpdatedBy
                })
            })
            .catch(() => {
                currentProtectionValue.current = 0;
                currentOnboardingValue.current = 0;
            })
    }

    function updateSecurityValues() {
        httpCall.put('locker/admin/settings', {
            SetupProtectionWindowInDays: setupProtectionValue,
            OnboardingWindowInDays: setupOnboardingValue
        })
            .then(() => {
                currentProtectionValue.current = setupProtectionValue;
                currentOnboardingValue.current = setupOnboardingValue;
                setShowToast(true);
                setToastProps({
                    message: <>You have successfully updated your security settings</>,
                    type: ToastMessageType.SUCCESS
                });
            })
            .catch(() => {
                currentProtectionValue.current = setupProtectionValue;
                currentOnboardingValue.current = setupOnboardingValue;
                setShowToast(true);
                setToastProps({
                    message: <>We could not update your security settings at this time</>,
                    type: ToastMessageType.WARNING
                });
            })
            .finally(() => refreshSecurityValues());
    }

    function isDisabled(): boolean {
        if (setupProtectionValue === currentProtectionValue.current && 
            setupOnboardingValue === currentOnboardingValue.current) {
                return true;
            }
        else if(isNaN(setupProtectionValue) || isNaN(setupOnboardingValue)) {
            return true;
        }

        return false;
    }
    
    return (
        <>
            <Toast show={showToast} closeToast={() => setShowToast(false)} messageType={toastProps?.type}>
                {toastProps?.message}
            </Toast>

            <h3 className="security-title">Security</h3>
            <div className="security-header">
                <h4>LOCKER SETUP PROTECTION</h4>
                <ToolTipWrapper id="highlight-tooltip1" className="tracks-side-tooltip">
                    <ReactTooltip id="highlight-tooltip1" place="top" className='thrive-tooltip' delayHide={1000} >
                        <span>Timeframe in which existing user who has changed their password will not be able to setup a Locker passcode</span>
                    </ReactTooltip>
                </ToolTipWrapper>
            </div>
            <p className="security-text">
            If a user changes their password, this is the time window in which users will not be able to setup a Locker passcode.
            </p>
            <Dropdown
                setValue={(value) => setSetupProtectionValue(+value)}
                defaultValue={getDefaultLabel(setupProtectionValue)}
                placeholder={getDefaultLabel(setupProtectionValue)}
                options={setupProtectionOptions}
                className="security-dropdown"
            />
            <div className="security-header">
                <h4>Locker Onboarding Window</h4>
                <ToolTipWrapper id="highlight-tooltip2" className="tracks-side-tooltip">
                    <ReactTooltip id="highlight-tooltip2" place="top" className='thrive-tooltip' delayHide={1000} >
                        <span>Timeframe in which new user who has changed their password during onboarding will be able to setup a Locker passcode</span>
                    </ReactTooltip>
                </ToolTipWrapper>
            </div>
            <p className="security-text">
            Time window that permits
             new users to setup a Locker passcode after changing their password during onboarding.
            </p>
            <Dropdown
                setValue={(value) => setSetupOnboardingValue(+value)}
                defaultValue={getDefaultLabel(setupOnboardingValue)}
                placeholder={getDefaultLabel(setupOnboardingValue)}
                options={setupOnboardingOptions}
                className="security-dropdown" 
            />
             {lastUpdate.lastUpdate && lastUpdate.UpdateBy
                    ?<div className="security-updated-wrapper">
                        <p>Last Updated on <span className="security-updated-date">{new Date(lastUpdate.lastUpdate).toLocaleDateString('en-gb')}</span> by:</p>
                        <p>{lastUpdate.UpdateBy}</p>
                    </div>
                    :<div style={{height: '30px'}}/>
            }
            <button
                className="security-btn"
                disabled={isDisabled()}
                onClick={updateSecurityValues}
            >
                Confirm Changes
            </button>
        </>
    )
};

export default LockerSecurity